import { createLegacyForumSearchRepository, legacySearchQuery, legacySearchUrl } from './forumLegacySearchRepository';
import { createForumQueryController } from '@/features/forum-next/services/forumQueryController';
import { forumError } from '@/features/forum-next/api/forumErrors';

// Two historical presentations, one applied-query lifecycle. No HTTP or Drupal
// field names in either component; changing a draft never changes the results.
export function legacyForumSearch({ multipart = false } = {}) {
  return {
    data() {
      const controller = createForumQueryController();
      return { controller, searchState: controller.state, appliedSearch: null, sections: [], sectionError: null, formError: null,
        keyword: '', selectedSection: '', exact: false, includeTopics: true, includeComments: true, batchSize: 10 };
    },
    computed: {
      identityKey() { return JSON.stringify(this.searchIdentity()); },
      loading() { return this.searchState.loading || this.searchState.refreshing; },
      error() { return this.formError?.message || this.searchState.error?.message || null; },
      topics() { return this.searchState.data?.topics || []; },
      comments() { return this.searchState.data?.comments || []; },
      resultsTopics() { return this.topics; }, resultsComments() { return this.comments; },
      totalTopics() { return this.searchState.data?.totalTopics || 0; }, totalComments() { return this.searchState.data?.totalComments || 0; },
      topicPages() { return Math.ceil(this.totalTopics / 10); },
      totalPages() { return this.searchState.data?.pages || 1; },
      combinedCount() { return this.totalTopics + this.totalComments; },
      currentPage() { return (this.appliedSearch?.page || 1) - 1; },
      searchedKeyword() { return this.appliedSearch?.q || ''; }, searchedSection() { return this.appliedSearch?.section_id || ''; },
      searchExact() { return Boolean(this.appliedSearch?.exact); },
      searchIncludeTopics() { return this.appliedSearch?.topics !== false; }, searchIncludeComments() { return this.appliedSearch?.comments !== false; },
      searched() { return Boolean(this.appliedSearch?.q); },
      resultsReady() { return this.searched || this.loading || Boolean(this.error); },
      showPagination() { return !this.loading && !this.error && this.totalPages > 1; },
      hasMoreResults() { return this.currentPage + 1 < this.totalPages; }
    },
    watch: {
      '$route.fullPath'() { this.restoreSearch(); },
      identityKey() { this.repository.reset(); this.controller.clear(); this.sections = []; this.fetchSections(); this.restoreSearch(); }
    },
    created() {
      this.searchAlive = true;
      this.repository = createLegacyForumSearchRepository({ getIdentity: () => this.searchIdentity(), multipart });
      this.fetchSections(); this.restoreSearch();
    },
    beforeDestroy() { this.searchAlive = false; this.repository.reset(); this.controller.dispose(); },
    methods: {
      searchIdentity() {
        const user = this.$store.getters._g_User || {};
        return { uid: user.uid === undefined ? localStorage.getItem('uid') : user.uid,
          session: localStorage.getItem('user_access_token'), permissions: JSON.stringify([user.roles, this.$store.getters._g_UserFeatures]) };
      },
      async fetchSections() {
        this.sectionError = null;
        const owner = this.identityKey;
        try { const sections = await this.repository.sections(); if (this.searchAlive && this.identityKey === owner) this.sections = sections; }
        catch (error) { if (this.searchAlive && this.identityKey === owner) { this.sections = []; this.sectionError = forumError(error).message; } }
      },
      async restoreSearch(refresh = false) {
        const revision = this.searchRevision = (this.searchRevision || 0) + 1;
        this.formError = null;
        try {
          const query = legacySearchQuery(this.$route.query);
          this.appliedSearch = query;
          this.keyword = query.q; this.selectedSection = query.section_id || ''; this.exact = query.exact;
          this.includeTopics = query.topics; this.includeComments = query.comments;
          const key = this.identityKey + JSON.stringify(query);
          const value = await this.controller.load(key, () => this.repository.search(query, refresh));
          if (this.searchAlive && value && this.searchState.key === key && query.page > value.pages) {
            await this.navigateSearch({ ...this.$route.query, page: String(value.pages) }, true);
          }
        } catch (error) { if (this.searchAlive && revision === this.searchRevision) { this.controller.clear(); this.appliedSearch = null; this.formError = forumError(error); } }
      },
      navigateSearch(query, replace = false) {
        const destination = { name: this.$route.name, params: this.$route.params, query, hash: '' };
        if (this.$router.resolve(destination).route.fullPath === this.$route.fullPath) return this.restoreSearch(true);
        return this.$router[replace ? 'replace' : 'push'](destination).catch(error => {
          if (error.name !== 'NavigationDuplicated') throw error;
        });
      },
      newSearch() {
        this.formError = null;
        try {
          const query = legacySearchUrl({ q: this.keyword, section_id: this.selectedSection, exact: this.exact, topics: this.includeTopics, comments: this.includeComments });
          return this.navigateSearch({ ...(this.$route.name === 'Forum' ? { view: 'search' } : {}), ...query });
        } catch (error) { this.formError = forumError(error); }
      },
      performSearch() { return this.newSearch(); }, searchForum() { return this.restoreSearch(true); },
      nextPage() { if (this.hasMoreResults) return this.navigateSearch({ ...this.$route.query, page: String(this.currentPage + 2) }); },
      prevPage() { if (this.currentPage > 0) return this.navigateSearch({ ...this.$route.query, page: String(this.currentPage) }); }
    }
  };
}
